




























































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import AuthModule from '@/store/modules/Auth';

@Component
export default class DownlineBody extends Vue {
  AuthInstance = getModule(AuthModule, this.$store);

  @Prop() readonly data!: object;

  @Prop() readonly report!: Function;

  @Prop() readonly lock!: Function;

  @Prop() readonly editInfo!: Function;

  @Prop() readonly resetPassword!: Function;

  @Prop() readonly editPT!: Function;

  @Prop() readonly refillCredit!: Function;

  @Prop() readonly deductCredit!: Function;

  @Prop() readonly handleSub!: Function;

  @Prop() readonly startCount!: number;

  @Prop() readonly showFilterCurrency!: boolean;

  @Prop() readonly currencyRate!: any;

  editAgent(id) {
    this.$router.push({ name: 'EditAgent', params: { id } });
  }

  editMember(id) {
    this.$router.push({ name: 'EditMember', params: { id } });
  }

  isSuspend(user) {
    if (user.isSuspend) {
      return 'isSuspend';
    } else {
      return '';
    }
  }

  handleType(val: any) {
    const type = typeof val;
    if (type === 'object') {
      return val.$numberDecimal;
    } else {
      return val;
    }
  }

  calRate(value: number, currency: any) {
    return (value / this.currencyRate[currency]);
  }
}
